import { apiClient } from '~/api/client';
import { OperationResponse } from '~/types/api/client';
import { Paths } from '~/types/api/generatedApiClient';
import axios, { ResponseType } from '~/api/axios';
import { ExportBody, ExportCheck, Transaction } from '~/types';

export const getTransactions =
  (params: Paths.GetTransactionListByProfileId.QueryParameters) =>
  (): OperationResponse<Paths.GetTransactionListByProfileId.Responses.$200> => {
    return apiClient.paths['/transactions'].get({ ...params });
  };

export const getTransactionById = (id: string): ResponseType<Transaction> => {
  return axios.get(`/transactions/${id}`);
};

export const getTransactionsExportCheck = () => {
  return axios.get<ExportCheck>(`/v2/transactions/export/check`).then((res) => res.data);
};

export const getTransactionsExport = (body: ExportBody) => {
  return axios.post('/v2/transactions/export', body).then((res) => res.data);
};

export const getTransactionsExportStatus = (exportId: string) => {
  return axios.get(`/v2/transactions/export/${exportId}`).then((res) => res.data);
};

export const getTransactionsExportResult = (exportId: string) => {
  return axios
    .get(`/v2/transactions/export/${exportId}/result`, {
      responseType: 'blob',
    })
    .then((res) => res.data);
};
